/* global Stripe */
import React, {
  useEffect, useCallback, useState, useContext,
} from 'react';
import { withTheme } from '@material-ui/core';
import Flexor from '../Flexor';
import Button from '../Button';
import CenteredRow from '../CenteredRow';
import Input from '../Input';
import { AppContext } from '../AppProvider';
import {
  Container, StripeCardElement, StripeResultElement,
} from './styled.js';
let stripe;

function StripeInput({
  theme, submit: _submit, next, nextButtonLabel = 'Next',
}) {
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [cardElement, setCardElement] = useState(null);
  const { actions: { setLoading } } = useContext(AppContext);
  const submit = useCallback(() => {
    setLoading(true);
    getStripeToken().then(({
      ccToken, month, year, brand,
    }) => {
      setLoading(false);
      _submit({
        ccToken,
        firstName,
        lastName,
        month,
        year,
        paymentType: 'cc',
        cardBrand: brand,
      });
    }).catch(() => setLoading(false));
  }, [_submit, firstName, getStripeToken, lastName, setLoading]);

  useEffect(() => {
    //Mount Stripe element
    stripe = Stripe(process.env.GATSBY_STRIPE_PK);
    var elements = stripe.elements();
    const _cardElement = elements.create('card', {
      hidePostalCode: true,
      style: { backgroundColor: theme['text-field-background'] },
    });
    _cardElement.mount('#card-element');
    setCardElement(_cardElement);
  }, [theme]);

  const getStripeToken = useCallback(async () => {
    if (stripe) {
      const { paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

      if (paymentMethod) {
        const {
          id,
          card: {
            exp_month, exp_year, last4, brand,
          },
        } = paymentMethod;
        return {
          processorType: 'stripe',
          ccToken: id + last4,
          month: exp_month + '',
          year: (exp_year + '').substring(2, 4),
          brand,
        };
      } else {
        return {};
      };
    }
  }, [cardElement]);
  return (
    <Container onSubmit={submit} as="form">
      <CenteredRow style={{ width: 335 }}>
        <Input
          required
          value={firstName}
          update={setFirstName}
          label="First Name"
          style={{ marginRight: 20 }} />
        <Input
          required
          value={lastName}
          update={setLastName}
          label="Last Name" />
      </CenteredRow>
      <Flexor flex="0 0 20px" />
      <StripeCardElement data-cy="stripe-card-container" id="card-element" />
      <StripeResultElement id="card-result" />
      {
        next ? next(getStripeToken) : (
          <>
            <Flexor flex="0 0 20px" />
            <Button submit label={nextButtonLabel} />
          </>
        )
      }
    </Container>
  );
}

export default withTheme(StripeInput);